/* src/app/shared/components/ag-counter-field/ag-counter-field.component.scss */
.counter-wrapper .focused {
  background: #ffffff !important;
  border: 1px solid #dfdfdf !important;
}
.counter-wrapper .has-error {
  border: 1px solid #e55e5e !important;
}
.counter-wrapper .counter {
  display: flex;
  background: #f2f2f2;
  border-radius: 12px;
  align-items: center;
  justify-content: space-between;
  border: 1px solid transparent;
}
.counter-wrapper .counter .input {
  font-size: 14px;
  border: none;
  outline: none;
  background-color: transparent;
  padding: 0 !important;
}
.counter-wrapper .counter .placeholder {
  font-family: "Poppins-Regular";
  font-size: 14px;
  color: #5c5c5c;
  background-color: transparent;
  cursor: default;
}
.counter-wrapper .counter p {
  padding: 12px !important;
  width: 100%;
  cursor: text;
}
.counter-wrapper .counter .button-wrapper {
  border-left: 1px solid #dfdfdf;
  display: flex;
  flex-direction: column;
  min-width: 36px;
  height: 100%;
}
.counter-wrapper .counter .button-wrapper .up-button {
  border-bottom: 1px solid #dfdfdf;
  border-top-right-radius: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50%;
  width: 100%;
}
.counter-wrapper .counter .button-wrapper .down-button {
  border-bottom-right-radius: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50%;
  width: 100%;
}
.counter-wrapper .counter .button-wrapper .up-button:hover,
.counter-wrapper .counter .button-wrapper .down-button:hover {
  background: #ffffff;
  border: 1px solid #dfdfdf;
}
.counter-wrapper .counter .button-wrapper .disabled {
  cursor: default !important;
}
.counter-wrapper .counter .button-wrapper .disabled img {
  filter: brightness(0) saturate(100%) invert(87.5%);
}
.counter-wrapper .counter .button-wrapper .disabled:hover {
  background: #f2f2f2;
  border: none !important;
}
.counter-wrapper .info-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  padding-top: 4px;
}
.counter-wrapper .info-container .info-img {
  width: 12px;
  height: 12px;
  color: #222222;
}
.counter-wrapper .info-container .error-img {
  width: 12px;
  height: 12px;
  filter: brightness(0) saturate(100%) invert(61%) sepia(69%) saturate(2913%) hue-rotate(318deg) brightness(89%) contrast(102%);
}
.counter-wrapper .info-container .info-text {
  font-family: "Poppins-Regular";
  font-size: 12px;
  font-style: normal;
  line-height: 16px;
  margin-top: 1px;
}
input[type=number] {
  -moz-appearance: textfield;
  appearance: textfield;
}
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
p,
.counter-wrapper,
.button-wrapper {
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}
/*# sourceMappingURL=ag-counter-field.component.css.map */
